export default __webpack_public_path__ + "static/media/undraw_color__schemes_wv48.2edeca67.png";